import fp from 'lodash/fp';

import { createGridSort } from '../../common/helpermethods/HelperMethods';

export const getUseDollars = fp.get('monitoringSummary.useDollars');

export const getColumns = fp.get('monitoringSummary.columns');

export const getInitialised = fp.get('monitoringSummary.initialised');

export const getImSummaries = fp.get('monitoringSummary.imSummaries');

export const getLastUpdated = fp.get('monitoringSummary.lastUpdated');

export const getLoading = fp.get('monitoringSummary.loading');

export const getDateFrom = fp.flow(
    fp.find(obj => obj.definition.id === 'runDate'),
    fp.get('value.from')
);

export const getDateTo = fp.flow(
    fp.find(obj => obj.definition.id === 'runDate'),
    fp.get('value.to')
);

export const getCsas = fp.flow(
    fp.find(obj => obj.definition.id === 'csa'),
    fp.get('value')
);

export const getDefaultSort = fp.flow(
    fp.get('monitoringSummary.gridSorting'),
    result => createGridSort(result, 'monitoringSummary')
);

export const getCurrentServerFilters = fp.get('monitoringSummary.currentServerFilters');
